const Divider = {
  baseStyle: {
    opacity: "1",
    borderColor: "blueGray.300",
  },
};

export default Divider;
